var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePowerpointRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_8",
    "data-name": "Differenzmenge 8",
    d: "M17,19H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H17a2,2,0,0,1,2,2V17A2,2,0,0,1,17,19ZM7.492,6.916V12.5H8.708V10.484h1.424a1.794,1.794,0,0,0,.7-.132,1.571,1.571,0,0,0,.532-.364,1.612,1.612,0,0,0,.34-.56,2.263,2.263,0,0,0,0-1.453,1.594,1.594,0,0,0-.34-.563,1.572,1.572,0,0,0-.532-.365,1.794,1.794,0,0,0-.7-.132Zm2.5,2.513H8.708V7.972h1.28a.62.62,0,0,1,.427.139.527.527,0,0,1,.157.412v.352a.527.527,0,0,1-.157.412A.617.617,0,0,1,9.988,9.428Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePowerpointRegular);
export default __webpack_public_path__ + "static/media/file-powerpoint-regular.db654d4f69a58c766bf2a0e36197def6.svg";
export { ForwardRef as ReactComponent };